import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { inputCls } from "@/components/site/QuickRequestForm";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("ams_admin_token", r.data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(errMsg(err, "Accesso non riuscito"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-10" aria-label="AMS Travel"><img src="/brand/ams-logo-dark.webp" alt="AMS Travel" className="h-14 w-auto" /></Link>
        <form onSubmit={submit} className="bg-white rounded-3xl shadow-soft-xl p-8 md:p-10 space-y-5">
          <div className="text-center mb-2">
            <div className="w-12 h-12 mx-auto rounded-full bg-sea/15 flex items-center justify-center"><Lock size={20} className="text-sea" /></div>
            <h1 className="font-serif text-2xl text-ocean mt-4">Area riservata</h1>
            <p className="text-sm text-ocean/55 mt-1">Gestione prenotazioni e contenuti</p>
          </div>
          <div>
            <label className="block text-[11px] tracking-[0.2em] uppercase text-ocean/60 mb-2">Email</label>
            <input type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div>
            <label className="block text-[11px] tracking-[0.2em] uppercase text-ocean/60 mb-2">Password</label>
            <input type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>
          <button type="submit" disabled={loading} className="w-full py-3.5 bg-ocean text-ivory text-sm font-medium tracking-wider uppercase rounded-xl hover:bg-ocean-700 disabled:opacity-60 btn-lift" data-testid="admin-login-submit">
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
